import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setDefaultEnabled: YJSChangeHandler<
  DatabaseChangeType.SET_DEFAULT_ENABLED
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.defaultEnabled = change.defaultEnabled;
  });
};
